import { call, put } from 'redux-saga/effects';
import authActions from 'src/store/Auth/actions';
import notificationActions from 'src/store/Notifications/actions';

/*  SAFE SAGA CALL FOR ERROR HANDLING */
export function sagaWrapper(sagaFn: any, errorAction?: any) {
	return function* () {
		try {
			// @ts-ignore
			return yield call(sagaFn, arguments[0]);
		} catch (error) {
			console.log('Error:', error);

			// @ts-ignore
			if (error.message === 'Network Error') {
				yield put(
					notificationActions.add(
						'error',
						'Error de red, verifica tu conexión',
					),
				);
			}

			// @ts-ignore
			if (error.response) {
				// @ts-ignore
				if (error.response.status === 401) {
					yield put(authActions.logout());
				} else {
					// @ts-ignore
					const message = error?.response?.data?.message
					// @ts-ignore
					yield put(
						notificationActions.add(
							'error',
								message ?? 'Ocurrió un error',
						),
					);
				}
			}

			// @ts-ignore
			if (error.message === 'Operation canceled') {
				return;
			}

			// yield put(notificationActions.add('error', 'Ocurrió un error'));
			// @ts-ignore
			if (errorAction && error.message !== 'Operation canceled') {
				yield put(errorAction);
			}
		}
	};
}
